export default "__VITE_ASSET__w$zWzdfP__"